/* ===========================================================
   YOUR OLIVE TREE — Build a Box
   Client-side box composer: size limits, live 15% pricing,
   fly-to-box animation, hover preview, cart + discount handoff.
   =========================================================== */
(function () {
  'use strict';

  /* ---------- money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var fmt = format || '${{amount}}';

    function defaultTo(num, precision, thousands, decimal) {
      precision = isNaN(precision) ? 2 : precision;
      thousands = thousands === undefined ? ',' : thousands;
      decimal = decimal === undefined ? '.' : decimal;
      var n = (cents / 100).toFixed(precision);
      var parts = n.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }

    switch ((fmt.match(placeholderRegex) || [])[1]) {
      case 'amount': value = defaultTo(cents, 2); break;
      case 'amount_no_decimals': value = defaultTo(cents, 0); break;
      case 'amount_with_comma_separator': value = defaultTo(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = defaultTo(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = defaultTo(cents, 2, ' ', ','); break;
      case 'amount_with_apostrophe_separator': value = defaultTo(cents, 2, "'", '.'); break;
      default: value = defaultTo(cents, 2);
    }
    return fmt.replace(placeholderRegex, value);
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /* ---------- one builder instance ---------- */
  function BoxBuilder(root) {
    this.root = root;
    var cfgEl = root.querySelector('[data-bb-config]');
    try { this.config = JSON.parse(cfgEl.textContent); } catch (e) { this.config = { sizes: [], discountPct: 0 }; }
    this.moneyFormat = root.getAttribute('data-money-format') || '${{amount}}';
    this.cartAddUrl = root.getAttribute('data-cart-add-url') || '/cart/add.js';
    this.cartUrl = root.getAttribute('data-cart-url') || '/cart';
    this.discountCode = (root.getAttribute('data-discount-code') || '').trim();
    this.pct = parseFloat(root.getAttribute('data-discount-pct')) || this.config.discountPct || 0;

    this.size = null;            // active size object
    this.items = {};             // id -> { qty, price, title, img, imgLg, el }
    this.order = [];             // insertion order of ids (for slot fill)
    this.token = 'bb-' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);

    this.cache();
    this.bind();
    this.renderSlots();
  }

  BoxBuilder.prototype.cache = function () {
    var r = this.root;
    this.el = {
      body: r.querySelector('[data-bb-body]'),
      sizes: Array.prototype.slice.call(r.querySelectorAll('[data-bb-size]')),
      grid: r.querySelector('[data-bb-grid]'),
      items: Array.prototype.slice.call(r.querySelectorAll('[data-bb-item]')),
      filters: Array.prototype.slice.call(r.querySelectorAll('[data-bb-filter]')),
      slots: r.querySelector('[data-bb-slots]'),
      meterFill: r.querySelector('[data-bb-meter-fill]'),
      meterText: r.querySelector('[data-bb-meter-text]'),
      lines: r.querySelector('[data-bb-lines]'),
      panelSize: r.querySelector('[data-bb-panel-size]'),
      itemsTotal: r.querySelector('[data-bb-items-total]'),
      itemsLabel: r.querySelector('[data-bb-items-label]'),
      discountRow: r.querySelector('[data-bb-discount-row]'),
      discountAmount: r.querySelector('[data-bb-discount-amount]'),
      discountPctEls: Array.prototype.slice.call(r.querySelectorAll('[data-bb-discount-pct]')),
      baseLabel: r.querySelector('[data-bb-base-label]'),
      baseAmount: r.querySelector('[data-bb-base-amount]'),
      grandTotal: r.querySelector('[data-bb-grand-total]'),
      savePill: r.querySelector('[data-bb-save-pill]'),
      cta: r.querySelector('[data-bb-cta]'),
      ctaText: r.querySelector('[data-bb-cta-text]'),
      ctaHint: r.querySelector('[data-bb-cta-hint]'),
      minEl: r.querySelector('[data-bb-min]'),
      flyerLayer: r.querySelector('[data-bb-flyer-layer]'),
      preview: r.querySelector('[data-bb-preview]'),
      previewImg: r.querySelector('[data-bb-preview-img]'),
      previewName: r.querySelector('[data-bb-preview-name]'),
      previewPrice: r.querySelector('[data-bb-preview-price]'),
      mobilebar: r.querySelector('[data-bb-mobilebar]'),
      mbCount: r.querySelector('[data-bb-mb-count]'),
      mbTotal: r.querySelector('[data-bb-mb-total]'),
      mbCta: r.querySelector('[data-bb-mb-cta]'),
      mbCtaText: r.querySelector('[data-bb-mb-cta-text]')
    };
    var self = this;
    this.el.discountPctEls.forEach(function (e) { e.textContent = self.pct; });
  };

  BoxBuilder.prototype.bind = function () {
    var self = this;

    this.el.sizes.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.classList.contains('is-disabled')) return;
        self.selectSize(btn.getAttribute('data-bb-size'));
      });
    });

    this.el.filters.forEach(function (btn) {
      btn.addEventListener('click', function () { self.filter(btn.getAttribute('data-bb-filter'), btn); });
    });

    this.el.items.forEach(function (li) {
      var add = li.querySelector('[data-bb-add]');
      var inc = li.querySelector('[data-bb-inc]');
      var dec = li.querySelector('[data-bb-dec]');
      var name = li.querySelector('.bb-item__name');
      if (add) add.addEventListener('click', function () { self.changeQty(li, +1, add); });
      if (inc) inc.addEventListener('click', function () { self.changeQty(li, +1, inc); });
      if (dec) dec.addEventListener('click', function () { self.changeQty(li, -1, dec); });
      if (name) {
        name.addEventListener('mouseenter', function (e) { self.showPreview(li, e); });
        name.addEventListener('mousemove', function (e) { self.movePreview(e); });
        name.addEventListener('mouseleave', function () { self.hidePreview(); });
        name.addEventListener('focus', function () { self.showPreview(li, null); });
        name.addEventListener('blur', function () { self.hidePreview(); });
      }
    });

    window.addEventListener('scroll', function () { self.hidePreview(); }, { passive: true });

    if (this.el.cta) this.el.cta.addEventListener('click', function () { self.addToCart(); });
    if (this.el.mbCta) this.el.mbCta.addEventListener('click', function () { self.addToCart(); });
  };

  /* ---------- size ---------- */
  BoxBuilder.prototype.selectSize = function (key) {
    var size = null;
    for (var i = 0; i < this.config.sizes.length; i++) {
      if (this.config.sizes[i].key === key) { size = this.config.sizes[i]; break; }
    }
    if (!size) return;
    this.size = size;

    this.el.sizes.forEach(function (btn) {
      var on = btn.getAttribute('data-bb-size') === key;
      btn.classList.toggle('is-selected', on);
      btn.setAttribute('aria-checked', on ? 'true' : 'false');
    });

    if (this.el.body.hidden) {
      this.el.body.hidden = false;
      this.el.body.classList.add('is-revealed');
      // bring the catalog into view on first reveal
      var self = this;
      requestAnimationFrame(function () {
        self.el.body.scrollIntoView({ behavior: prefersReducedMotion() ? 'auto' : 'smooth', block: 'start' });
      });
    }
    this.el.panelSize.textContent = size.label;
    if (this.el.minEl) this.el.minEl.textContent = size.min;
    if (this.el.mobilebar) this.el.mobilebar.hidden = false;

    this.renderSlots();
    this.render();
  };

  /* ---------- filter ---------- */
  BoxBuilder.prototype.filter = function (cat, btn) {
    this.el.filters.forEach(function (b) {
      var on = b === btn;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    this.el.items.forEach(function (li) {
      var show = cat === 'all' || li.getAttribute('data-category') === cat;
      li.classList.toggle('is-hidden', !show);
    });
  };

  /* ---------- counts ---------- */
  BoxBuilder.prototype.totalQty = function () {
    var n = 0;
    for (var id in this.items) if (this.items.hasOwnProperty(id)) n += this.items[id].qty;
    return n;
  };

  /* ---------- add / remove ---------- */
  BoxBuilder.prototype.changeQty = function (li, delta, sourceBtn) {
    if (!this.size) return;
    var id = li.getAttribute('data-id');
    var current = this.items[id] ? this.items[id].qty : 0;
    var total = this.totalQty();

    if (delta > 0) {
      if (li.getAttribute('data-available') === 'false') return;
      if (total >= this.size.max) { this.flashFull(); return; }
    }

    var next = current + delta;
    if (next < 0) next = 0;

    if (next === 0) {
      delete this.items[id];
      this.order = this.order.filter(function (x) { return x !== id; });
    } else {
      if (!this.items[id]) {
        this.items[id] = {
          qty: 0,
          price: parseInt(li.getAttribute('data-price'), 10) || 0,
          title: li.getAttribute('data-title') || '',
          img: li.getAttribute('data-img') || '',
          imgLg: li.getAttribute('data-img-lg') || '',
          el: li
        };
        this.order.push(id);
      }
      this.items[id].qty = next;
    }

    this.syncCard(li);
    if (delta > 0) this.fly(li);
    this.render(delta > 0);
  };

  BoxBuilder.prototype.flashFull = function () {
    var self = this;
    if (this.el.ctaHint) {
      this.el.ctaHint.textContent = 'Your ' + this.size.label + ' box is full (' + this.size.max + ' items). Remove one to swap.';
      clearTimeout(this._hintTimer);
      this._hintTimer = setTimeout(function () { self.updateHint(); }, 2600);
    }
    this.root.querySelectorAll('.bb-item.is-in-box').forEach(function (li) {
      li.classList.add('is-shake');
    });
    setTimeout(function () {
      self.root.querySelectorAll('.bb-item').forEach(function (li) { li.classList.remove('is-shake'); });
    }, 400);
  };

  BoxBuilder.prototype.syncCard = function (li) {
    var id = li.getAttribute('data-id');
    var entry = this.items[id];
    var add = li.querySelector('[data-bb-add]');
    var stepper = li.querySelector('[data-bb-stepper]');
    var qtyEl = li.querySelector('[data-bb-qty]');
    if (entry && entry.qty > 0) {
      li.classList.add('is-in-box');
      if (add) add.hidden = true;
      if (stepper) stepper.hidden = false;
      if (qtyEl) {
        qtyEl.textContent = entry.qty;
        qtyEl.classList.remove('is-bumped');
        void qtyEl.offsetWidth;
        qtyEl.classList.add('is-bumped');
      }
    } else {
      li.classList.remove('is-in-box');
      if (add) add.hidden = false;
      if (stepper) stepper.hidden = true;
      if (qtyEl) qtyEl.textContent = 0;
    }
  };

  /* ---------- slots ---------- */
  BoxBuilder.prototype.renderSlots = function () {
    if (!this.el.slots) return;
    var max = this.size ? this.size.max : 0;
    this.el.slots.innerHTML = '';
    for (var i = 0; i < max; i++) {
      var li = document.createElement('li');
      li.className = 'bb__slot';
      this.el.slots.appendChild(li);
    }
  };

  BoxBuilder.prototype.fillSlots = function (animateNew) {
    if (!this.el.slots) return;
    var slots = this.el.slots.children;
    // build flat list of thumbnails by order/qty
    var thumbs = [];
    for (var i = 0; i < this.order.length; i++) {
      var entry = this.items[this.order[i]];
      if (!entry) continue;
      for (var q = 0; q < entry.qty; q++) thumbs.push(entry.img);
    }
    for (var s = 0; s < slots.length; s++) {
      var slot = slots[s];
      var wasFilled = slot.classList.contains('is-filled');
      if (s < thumbs.length) {
        if (!wasFilled) {
          slot.classList.add('is-filled');
          slot.innerHTML = '<img src="' + thumbs[s] + '" alt="">';
          if (animateNew && s === thumbs.length - 1) {
            slot.classList.remove('just-filled');
            void slot.offsetWidth;
            slot.classList.add('just-filled');
          }
        } else {
          var img = slot.querySelector('img');
          if (img && img.getAttribute('src') !== thumbs[s]) img.setAttribute('src', thumbs[s]);
        }
      } else if (wasFilled) {
        slot.classList.remove('is-filled', 'just-filled');
        slot.innerHTML = '';
      }
    }
  };

  /* ---------- fly animation ---------- */
  BoxBuilder.prototype.fly = function (li) {
    if (prefersReducedMotion()) return;
    var img = li.querySelector('.bb-item__media img');
    var box = this.root.querySelector('[data-bb-box-visual]');
    var barVisible = this.el.mobilebar && !this.el.mobilebar.hidden &&
      getComputedStyle(this.el.mobilebar).display !== 'none';
    var target;
    if (barVisible) {
      target = this.el.mobilebar;            // phone: fly to the sticky bar
    } else if (box && box.offsetParent !== null) {
      target = box;                          // desktop/tablet: fly to the box visual
    } else {
      target = this.el.cta;
    }
    if (!img || !target) return;

    var from = img.getBoundingClientRect();
    var to = target.getBoundingClientRect();
    var clone = img.cloneNode(true);
    clone.className = 'bb__flyer';
    clone.style.left = from.left + 'px';
    clone.style.top = from.top + 'px';
    clone.style.width = from.width + 'px';
    clone.style.height = from.height + 'px';
    this.el.flyerLayer.appendChild(clone);

    var dx = (to.left + to.width / 2) - (from.left + from.width / 2);
    var dy = (to.top + to.height / 2) - (from.top + from.height / 2);

    requestAnimationFrame(function () {
      clone.style.transition = 'transform 0.62s cubic-bezier(0.5, 0, 0.2, 1), opacity 0.62s ease-in';
      clone.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(0.18) rotate(-8deg)';
      clone.style.opacity = '0.25';
    });
    clone.addEventListener('transitionend', function () {
      clone.remove();
    });
    setTimeout(function () { if (clone.parentNode) clone.remove(); }, 900);
  };

  /* ---------- preview popover ---------- */
  BoxBuilder.prototype.showPreview = function (li, evt) {
    var p = this.el.preview;
    if (!p) return;
    this.el.previewImg.src = li.getAttribute('data-img-lg') || li.getAttribute('data-img') || '';
    this.el.previewName.textContent = li.getAttribute('data-title') || '';
    this.el.previewPrice.textContent = formatMoney(li.getAttribute('data-price'), this.moneyFormat);
    p.setAttribute('aria-hidden', 'false');
    p.classList.add('is-visible');
    if (evt) { this.movePreview(evt); }
    else { this.positionPreviewTo(li); }
  };

  BoxBuilder.prototype.movePreview = function (evt) {
    var p = this.el.preview;
    if (!p || !p.classList.contains('is-visible')) return;
    var pad = 16;
    var w = p.offsetWidth || 230;
    var h = p.offsetHeight || 260;
    var x = evt.clientX + 20;
    var y = evt.clientY - h / 2;
    if (x + w + pad > window.innerWidth) x = evt.clientX - w - 20;
    if (y < pad) y = pad;
    if (y + h + pad > window.innerHeight) y = window.innerHeight - h - pad;
    p.style.left = x + 'px';
    p.style.top = y + 'px';
  };

  BoxBuilder.prototype.positionPreviewTo = function (li) {
    var p = this.el.preview;
    var rect = li.getBoundingClientRect();
    var pad = 16;
    var w = p.offsetWidth || 230;
    var h = p.offsetHeight || 260;
    var x = rect.right + 12;
    var y = rect.top + rect.height / 2 - h / 2;
    if (x + w + pad > window.innerWidth) x = rect.left - w - 12;
    if (x < pad) x = pad;
    if (y < pad) y = pad;
    if (y + h + pad > window.innerHeight) y = window.innerHeight - h - pad;
    p.style.left = x + 'px';
    p.style.top = y + 'px';
  };

  BoxBuilder.prototype.hidePreview = function () {
    if (!this.el.preview) return;
    this.el.preview.classList.remove('is-visible');
    this.el.preview.setAttribute('aria-hidden', 'true');
  };

  /* ---------- render panel + pricing ---------- */
  BoxBuilder.prototype.render = function (animateNew) {
    var total = this.totalQty();
    var subtotal = 0;
    for (var id in this.items) if (this.items.hasOwnProperty(id)) subtotal += this.items[id].price * this.items[id].qty;

    var discount = Math.round(subtotal * (this.pct / 100));
    var base = this.size ? this.size.base : 0;
    var grand = subtotal - discount + base;

    // lines
    this.renderLines();
    this.fillSlots(animateNew);

    // meter
    var max = this.size ? this.size.max : 0;
    var min = this.size ? this.size.min : 0;
    var pctFill = max ? Math.min(100, (total / max) * 100) : 0;
    this.el.meterFill.style.width = pctFill + '%';
    this.el.meterFill.classList.toggle('is-full', total >= max && max > 0);
    this.el.meterFill.classList.toggle('is-min-reached', total >= min && total < max);

    if (total === 0) {
      this.el.meterText.innerHTML = 'Add <strong>' + min + '–' + max + '</strong> items to your ' + (this.size ? this.size.label : '') + ' box.';
    } else if (total < min) {
      this.el.meterText.innerHTML = '<strong>' + total + ' of ' + max + '</strong> · add ' + (min - total) + ' more to reach the minimum.';
    } else if (total < max) {
      this.el.meterText.innerHTML = '<strong>' + total + ' of ' + max + '</strong> items · room for ' + (max - total) + ' more.';
    } else {
      this.el.meterText.innerHTML = '<strong>' + total + ' of ' + max + '</strong> · your box is full.';
    }

    // summary
    this.el.itemsLabel.textContent = 'Items (' + total + ')';
    this.el.itemsTotal.textContent = formatMoney(subtotal, this.moneyFormat);

    if (discount > 0) {
      this.el.discountRow.hidden = false;
      this.el.discountAmount.textContent = '−' + formatMoney(discount, this.moneyFormat);
    } else {
      this.el.discountRow.hidden = true;
    }

    this.el.baseLabel.textContent = (this.size ? this.size.label : '') + ' box';
    this.el.baseAmount.textContent = formatMoney(base, this.moneyFormat);
    this.el.grandTotal.textContent = formatMoney(grand, this.moneyFormat);

    if (this.el.mbTotal) this.el.mbTotal.textContent = formatMoney(grand, this.moneyFormat);
    if (this.el.mbCount) this.el.mbCount.textContent = total + (total === 1 ? ' item' : ' items');

    if (discount > 0) {
      this.el.savePill.hidden = false;
      this.el.savePill.textContent = 'You save ' + formatMoney(discount, this.moneyFormat) + ' · ' + this.pct + '% off every item';
      if (animateNew) {
        this.el.savePill.classList.remove('is-bumped');
        void this.el.savePill.offsetWidth;
        this.el.savePill.classList.add('is-bumped');
      }
    } else {
      this.el.savePill.hidden = true;
    }

    // block cards when full
    var full = max > 0 && total >= max;
    this.el.items.forEach(function (li) {
      li.classList.toggle('is-blocked', full && !li.classList.contains('is-in-box'));
    });

    // a size that can no longer hold what's in the box is disabled
    var self = this;
    this.el.sizes.forEach(function (btn) {
      var key = btn.getAttribute('data-bb-size');
      var sz = null;
      for (var i = 0; i < self.config.sizes.length; i++) {
        if (self.config.sizes[i].key === key) { sz = self.config.sizes[i]; break; }
      }
      var tooSmall = sz && !btn.classList.contains('is-selected') && total > sz.max;
      btn.classList.toggle('is-disabled', !!tooSmall);
      btn.setAttribute('aria-disabled', tooSmall ? 'true' : 'false');
      btn.title = tooSmall ? 'Remove items to choose this smaller box' : '';
    });

    // CTA state
    this.updateCta(total, min);
  };

  BoxBuilder.prototype.updateCta = function (total, min) {
    var cta = this.el.cta;
    var ready = total >= min && min > 0;
    if (ready) {
      cta.disabled = false;
      this.el.ctaText.innerHTML = 'Add box to cart';
    } else {
      cta.disabled = true;
      var need = min - total;
      this.el.ctaText.innerHTML = 'Add at least <span data-bb-min>' + min + '</span> items' + (total > 0 ? ' (' + need + ' more)' : '');
    }
    if (this.el.mbCta) {
      this.el.mbCta.disabled = !ready;
      if (this.el.mbCtaText) {
        this.el.mbCtaText.textContent = ready ? 'Add box to cart' : (total > 0 ? (min - total) + ' more to go' : 'Add ' + min + '+ items');
      }
    }
    this.updateHint();
  };

  BoxBuilder.prototype.updateHint = function () {
    if (!this.el.ctaHint) return;
    this.el.ctaHint.textContent = '';
  };

  BoxBuilder.prototype.renderLines = function () {
    var lines = this.el.lines;
    if (!lines) return;
    lines.innerHTML = '';
    var self = this;
    this.order.forEach(function (id) {
      var entry = self.items[id];
      if (!entry) return;
      var li = document.createElement('li');
      li.className = 'bb__line';
      var lineTotal = entry.price * entry.qty;
      var qtyChip = entry.qty > 1 ? '<span class="bb__line-qty">×' + entry.qty + '</span>' : '';
      li.innerHTML =
        '<img class="bb__line-thumb" src="' + entry.img + '" alt="">' +
        '<span class="bb__line-name">' + escapeHtml(entry.title) + qtyChip + '</span>' +
        '<span class="bb__line-price">' + formatMoney(lineTotal, self.moneyFormat) + '</span>' +
        '<button type="button" class="bb__line-remove" aria-label="Remove ' + escapeHtml(entry.title) + '">' +
        '<svg viewBox="0 0 16 16" fill="none"><path d="M4 4l8 8M12 4l-8 8" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg></button>';
      li.querySelector('.bb__line-remove').addEventListener('click', function () {
        var card = entry.el;
        delete self.items[id];
        self.order = self.order.filter(function (x) { return x !== id; });
        if (card) self.syncCard(card);
        self.render();
      });
      lines.appendChild(li);
    });
    // only fade the edges when the list actually scrolls
    lines.classList.toggle('is-short', lines.scrollHeight <= lines.clientHeight + 1);
  };

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------- add to cart ---------- */
  BoxBuilder.prototype.addToCart = function () {
    var self = this;
    if (!this.size) return;
    var total = this.totalQty();
    if (total < this.size.min) return;

    var contents = [];
    var payload = [];
    var boxLabel = this.size.label + ' box (' + total + ' items)';

    this.order.forEach(function (id) {
      var entry = self.items[id];
      if (!entry || entry.qty <= 0) return;
      contents.push(entry.qty + '× ' + entry.title);
      payload.push({
        id: parseInt(id, 10),
        quantity: entry.qty,
        properties: { 'Box': boxLabel, '_bb_token': self.token }
      });
    });

    // box base fee line
    var baseVid = this.size.variantId ? parseInt(this.size.variantId, 10) : null;
    if (baseVid) {
      payload.unshift({
        id: baseVid,
        quantity: 1,
        properties: { 'Box contents': contents.join(', '), '_bb_token': this.token }
      });
    }

    this.el.cta.classList.add('is-loading');
    this.el.cta.disabled = true;
    this.el.ctaText.textContent = 'Adding…';
    if (this.el.mbCta) {
      this.el.mbCta.classList.add('is-loading');
      this.el.mbCta.disabled = true;
      if (this.el.mbCtaText) this.el.mbCtaText.textContent = 'Adding…';
    }

    fetch(this.cartAddUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: payload })
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (d) { throw new Error(d.description || 'Could not add to cart.'); });
        return res.json();
      })
      .then(function () {
        if (self.discountCode) {
          window.location.href = '/discount/' + encodeURIComponent(self.discountCode) +
            '?redirect=' + encodeURIComponent(self.cartUrl);
        } else {
          window.location.href = self.cartUrl;
        }
      })
      .catch(function (err) {
        self.el.cta.classList.remove('is-loading');
        self.el.cta.disabled = false;
        self.el.ctaText.textContent = 'Add box to cart';
        if (self.el.mbCta) {
          self.el.mbCta.classList.remove('is-loading');
          self.el.mbCta.disabled = false;
          if (self.el.mbCtaText) self.el.mbCtaText.textContent = 'Add box to cart';
        }
        if (self.el.ctaHint) self.el.ctaHint.textContent = err.message || 'Something went wrong. Please try again.';
      });
  };

  /* ---------- shake style (injected) ---------- */
  var style = document.createElement('style');
  style.textContent =
    '@keyframes bb-shake{10%,90%{transform:translateX(-1px)}20%,80%{transform:translateX(2px)}30%,50%,70%{transform:translateX(-3px)}40%,60%{transform:translateX(3px)}}' +
    '.bb-item.is-shake.is-in-box{animation:bb-shake .4s}';
  document.head.appendChild(style);

  /* ---------- boot ---------- */
  function init() {
    document.querySelectorAll('[data-box-builder]').forEach(function (root) {
      if (root.__bbInit) return;
      root.__bbInit = true;
      new BoxBuilder(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
